import { Injectable } from '@angular/core';
import { LayerThematicStylesDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { globalUtilsHelper } from '@common-modules/shared/helpers/global-utils-helper';
import { LayerItemV2 } from '../models/layer-item';
import { genericMapUtils } from './generic-map-utils';

@Injectable({ providedIn: 'root' })
export class ThematicMapService {
  buildThematicLayerItem(
    baseLayerItem: LayerItemV2,
    thematic: LayerThematicStylesDto,
    layerItems: LayerItemV2[]
  ) {
    if (baseLayerItem) {
      const { nativeLayer, ...safeProps } = baseLayerItem;
      const thematicId = genericMapUtils.getThematicIdFromStyle(thematic);
      const thematicPaneIndex = this.getHighestPaneIndex(layerItems);

      const thematicLayerItem = {
        ...this.clone(safeProps),
        layerDefinition: {
          ...this.clone(baseLayerItem.layerDefinition),
          isThematic: true,
        },
        layerStyle: thematic,
        layerId: thematicId,
        layerName: thematicId,
        layerKey: thematicId,
        pane: thematicId,
        paneIndex: thematicPaneIndex,
      } as LayerItemV2;

      return thematicLayerItem;
    }
    return undefined;
  }
  private clone = (data) => globalUtilsHelper.clone(data, true);

  private getHighestPaneIndex = (layerItems: LayerItemV2[]): number => {
    const paneIndexes = layerItems.map((item) => item.paneIndex);
    return Math.max(...paneIndexes);
  };
}
